import { Injectable, OnDestroy } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';

import * as CurrentUserActions from './current-user.actions';

import { catchError, map, switchMap, takeUntil } from 'rxjs/operators';

import { of, Subject } from 'rxjs';

import firebase from 'firebase/app';
import FirebaseError = firebase.FirebaseError;
import { UserService } from 'services/user.service';
import { OrgStaffUserInterfaceWithId } from '@sk/sk-interfaces';
import { environment } from 'environments/environment';
import { AuthUserService } from 'services/auth-user.service';


@Injectable()
export class CurrentUserEffects implements OnDestroy {
  unsubscribe$ = new Subject();


  constructor(private actions$: Actions,
              private authService: AuthUserService,
              private userService: UserService) {
  }


  getCurrentUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CurrentUserActions.getFireStoreCurrentUser),
      takeUntil(this.unsubscribe$),
      switchMap(() => {
        return this.authService.getIdToken();
      }),
      switchMap((idToken: firebase.auth.IdTokenResult) => {
        return this.userService.queryFirestoreCurrentUserById(idToken?.claims.organizationId, idToken?.claims.organizationUid);
      }),
      map((user: OrgStaffUserInterfaceWithId) => CurrentUserActions.fromFireStoreAddCurrentUser({ user: user })),
      catchError((error: FirebaseError) => {
        if (!environment.production) {
          console.error('Firestore Current User Error: ', error.message);
        }
        return of(CurrentUserActions.fromFireStoreCurrentUserError({
          error
        }));
      })
    )
  );


  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
